interface Stat {
  icon: string;
  value: number;
  suffix?: string;
  label: string;
}

interface StatStripProps {
  stats: Stat[];
  dark?: boolean;
}

export default function StatStrip({ stats, dark = false }: StatStripProps) {
  return (
    <section className={dark ? "bg-accent-950 py-12 md:py-14" : "bg-background-100 py-12 md:py-14"}>
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <div className="grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-5">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className={`flex flex-col items-center rounded-lg border p-5 text-center ${
                dark ? "border-white/10 bg-white/5" : "border-background-200 bg-background-50"
              }`}
            >
              <span
                className={`flex h-11 w-11 items-center justify-center rounded-md ${
                  dark ? "bg-primary-500 text-background-50" : "bg-primary-100 text-primary-700"
                }`}
              >
                <i className={`${stat.icon} text-xl`} aria-hidden="true" />
              </span>
              <p className={`mt-3 font-heading text-2xl font-extrabold md:text-3xl ${dark ? "text-background-50" : "text-foreground-950"}`}>
                {stat.value}
                {stat.suffix}
              </p>
              <p className={`mt-1 text-xs md:text-sm ${dark ? "text-background-300" : "text-foreground-600"}`}>
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}